import cn from 'classnames';
import { useSelector } from 'react-redux';
import { hasElements, rm } from 'utils';
import { selectContactBlocks } from 'components/Footer/selector';
import styles from './contact.scss';
import { IconCheckmark, IconPhone } from 'components/Shared/Icon';
import { Button } from 'components/Button';

interface Props {
  className?: string;
}

export const Contact = ({ className }: Props) => {
  const contactBlocks = useSelector(selectContactBlocks);
  if (!hasElements(contactBlocks)) {
    return null;
  }

  return (
    <div className={cn(styles.contact, className)}>
      <h2 className={styles.heading}>{rm('contactinfo_contactus')}</h2>
      {contactBlocks.map(contactBlock => (
        <div key={contactBlock.title} className={styles.contactBlock}>
          <div className={styles.text}>
            <p className={styles.contactTitle}>
              <span>{contactBlock.title}</span>
              <span>&nbsp;-&nbsp;</span>
              <span>{contactBlock.subTitle}</span>
            </p>
            <ul className={styles.contactUsps}>
              {contactBlock.usps.map(usp => (
                <li key={usp}>
                  <IconCheckmark className={styles.checkmarkIcon} size="small" />
                  &nbsp;
                  {usp}
                </li>
              ))}
            </ul>
          </div>
          <Button href={`tel:${contactBlock.phoneNumber}`} className={styles.contactButton}>
            <IconPhone className={styles.phoneIcon} />
            {contactBlock.phoneNumber}
          </Button>
        </div>
      ))}
    </div>
  );
};
